// Returns 'YYYY-MM-DD' for a given Date object (UTC)
export function fmtDate(d) {
  const y   = d.getUTCFullYear();
  const m   = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Returns the Monday of the week containing the given Date
export function weekStart(d = new Date()) {
  const dt   = new Date(d);
  const day  = dt.getUTCDay(); // 0=Sun
  const diff = day === 0 ? -6 : 1 - day;
  dt.setUTCDate(dt.getUTCDate() + diff);
  return dt;
}

// Returns the Sunday of the week containing the given Date
export function weekEnd(d = new Date()) {
  const mon = weekStart(d);
  const sun = new Date(mon);
  sun.setUTCDate(mon.getUTCDate() + 6);
  return sun;
}

// Advance a date by N days
export function addDays(d, n) {
  const dt = new Date(d);
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt;
}

// Day letter for a 'YYYY-MM-DD' string: M T W R F S S
const LETTERS = ['S', 'M', 'T', 'W', 'R', 'F', 'S'];
export function dayLetter(dateStr) {
  const d = new Date(dateStr + 'T00:00:00Z');
  return LETTERS[d.getUTCDay()];
}

// 'YYYY-MM-DD' → day-of-month number, zero-padded
export function dayNum(dateStr) {
  return dateStr.slice(8); // last 2 chars already padded from DB
}

// Display label for a date: 'M · 14'
export function dayLabel(dateStr) {
  return `${dayLetter(dateStr)} · ${dayNum(dateStr)}`;
}

// 7-day array of 'YYYY-MM-DD' strings for a week starting on monday
export function weekDays(mondayDate) {
  return Array.from({ length: 7 }, (_, i) => fmtDate(addDays(mondayDate, i)));
}

// Pretty week range: 'Apr 14 – Apr 20, 2026'
export function weekRangeLabel(mondayDate) {
  const opts = { month: 'short', day: 'numeric', timeZone: 'UTC' };
  const sun  = addDays(mondayDate, 6);
  const year = sun.getUTCFullYear();
  return `${mondayDate.toLocaleDateString('en-US', opts)} – ${sun.toLocaleDateString('en-US', opts)}, ${year}`;
}
